import React from "react";
import Modal from "react-bootstrap/Modal";

import Red_Round_Btn from "../../common-btn/red_round_btn/Red_Round_Btn";
import "./View_Prescription_Modal.css";

const View_Prescription_Modal = (props) => {

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Prescription_Modal Logout_Modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="content_div">
            <div className="img_holder">
                <img src={process.env.PUBLIC_URL + "/assets/images/my_account/prescription/img.png"} className="prescription_img"/>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default View_Prescription_Modal;
